import React from 'react';
import styled from 'styled-components';
import ScreenReaderText from '@components/utils/ScreenReaderText';
import breakpoints from '@repo/ui-components/breakpoints';

const iconHeight = 42;

const Container = styled.div`
  display: flex;
`;

const SocialLink = styled.a`
  height: ${iconHeight}px;
  width: ${iconHeight}px;
  margin: 0 1.5vw;
  cursor: pointer;

  @media (min-width: ${breakpoints.md}) {
    margin-left: 0;
    margin-right: 0.5vw;
  }

  img {
    max-height: 100%;
  }
`;

type SocialLinkItem = {
  title: string;
  link: string;
  icon?: React.ComponentType<React.ImgHTMLAttributes<HTMLImageElement>>;
  iconAltText?: string;
};

interface SocialIconsProps {
  socialLinks?: SocialLinkItem[];
}

const SocialIcons: React.FC<SocialIconsProps> = ({ socialLinks = [] }) => (
  <Container>
    {socialLinks.map(linkItem => (
      <SocialLink
        href={linkItem.link}
        rel="noopener noreferrer"
        target="_blank"
        key={linkItem.link}
      >
        {linkItem.icon ? (
          <linkItem.icon
            width={iconHeight}
            alt={linkItem.iconAltText}
            height={iconHeight}
          />
        ) : (
          linkItem.title
        )}
        <ScreenReaderText>{linkItem.title}</ScreenReaderText>
      </SocialLink>
    ))}
  </Container>
);

export default SocialIcons;
